import { FC } from 'react'

import styled from 'styled-components'
import { useForm, Controller } from 'react-hook-form'
import { notifications } from '@mantine/notifications'

import { Button } from 'src/Components/Button'
import { Input } from 'src/Components/Input/index.tsx'
import { Select } from 'src/Components/Select'
import { Textarea } from 'src/Components/Textarea/index.tsx'
import { AddToolBody } from 'src/Redux/api/toolsApi.ts'
import { Modal } from 'src/Components/Modal'

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px 0;
`

const StyledButton = styled(Button)`
  width: 200px;
  margin: 0 auto;
`

interface AddTransportModalProps {
  onClose: () => void
  onAddTool: (equipment: AddToolBody) => void
  isOpened: boolean
}

export const AddToolsModal: FC<AddTransportModalProps> = ({
  isOpened,
  onClose,
  onAddTool,
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<AddToolBody>({
    defaultValues: {
      name: '',
      toolWorkPrice: 0,
      condition: 'GOOD',
      description: '',
    },
  })

  const onSubmit = (data: AddToolBody): void => {
    onAddTool({
      name: data?.name,
      toolWorkPrice: Number(data?.toolWorkPrice),
      condition: data?.condition,
      description: data?.description,
    })
    reset()
    onClose()
    notifications.show({
      title: 'Навесное оборудование успешно добавлено',
      message: '',
      position: 'top-right',
    })
  }

  return (
    <Modal opened={isOpened} onClose={onClose} title='Добавить оборудование'>
      <ModalContainer>
        <Controller
          name='name'
          control={control}
          render={({ field }) => (
            <Input
              label='Название'
              placeholder='Название'
              error={errors.name?.message}
              {...field}
            />
          )}
        />

        <Controller
          name='toolWorkPrice'
          control={control}
          render={({ field }) => (
            <Input
              type='number'
              label='Цена работ'
              placeholder='Цена работ, руб./ч'
              error={errors.toolWorkPrice?.message}
              {...field}
            />
          )}
        />

        <Controller
          name='condition'
          control={control}
          render={({ field }) => (
            <Select
              {...field}
              label='Состояние'
              placeholder='Выберите состояние'
              data={[
                { value: 'GOOD', label: 'Хорошее' },
                { value: 'SATISFACTORY', label: 'Удовлетворительное' },
              ]}
              error={errors.condition?.message}
            />
          )}
        />

        <Controller
          name='description'
          control={control}
          render={({ field }) => (
            <Textarea
              label='Описание'
              placeholder='Описание'
              minRows={3}
              autosize
              {...field}
            />
          )}
        />

        <StyledButton onClick={handleSubmit(onSubmit)}>Добавить</StyledButton>
      </ModalContainer>
    </Modal>
  )
}
